// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Leibniz from "../Data.Leibniz/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Record_Builder from "../Record.Builder/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_Form_EditAsString from "../Restaumatic.Form.EditAsString/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_GenerateId from "../Restaumatic.Form.GenerateId/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_ChoiceRef from "../Specular.ChoiceRef/index.js";
import * as Specular_Extra_Async from "../Specular.Extra.Async/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_FormField from "../Specular.FormField/index.js";
import * as Specular_MultiChoiceRef from "../Specular.MultiChoiceRef/index.js";
import * as Specular_Profiling from "../Specular.Profiling/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Type_Data_RowList from "../Type.Data.RowList/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var WithOptions = function (x) {
    return x;
};
var Strict = (function () {
    function Strict() {

    };
    Strict.value = new Strict();
    return Strict;
})();
var Lax = (function () {
    function Lax() {

    };
    Lax.value = new Lax();
    return Lax;
})();
var RefWithOptions = function (x) {
    return x;
};
var FormDefM = function (x) {
    return x;
};
var Undefined = (function () {
    function Undefined() {

    };
    Undefined.value = new Undefined();
    return Undefined;
})();
var Invalid = (function () {
    function Invalid(value0) {
        this.value0 = value0;
    };
    Invalid.create = function (value0) {
        return new Invalid(value0);
    };
    return Invalid;
})();
var Valid = (function () {
    function Valid(value0) {
        this.value0 = value0;
    };
    Valid.create = function (value0) {
        return new Valid(value0);
    };
    return Valid;
})();
var InputRequired = (function () {
    function InputRequired() {

    };
    InputRequired.value = new InputRequired();
    return InputRequired;
})();
var FormField = function (x) {
    return x;
};
var MappedField = function (x) {
    return x;
};
var Attribute = function (x) {
    return x;
};
var writeValue = function (v) {
    return function (v1) {
        return function __do() {
            var handler = Effect_Ref.read(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "onWriteValue";
                }
            })())(Data_Symbol.SProxy.value)(v))();
            return handler(v)(v1)();
        };
    };
};
var writeRef = function (ref) {
    return function (value) {
        return Specular_Callback.triggerCallback(Specular_Ref.set(Effect_Class.monadEffectEffect)(ref))(value);
    };
};
var writeValueNoTouch = function (v) {
    return function (v1) {
        return function __do() {
            writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "value";
                }
            })())(Data_Symbol.SProxy.value)(v))(v1)();
            return Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "fire";
                }
            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "userEdit";
                }
            })())(Data_Symbol.SProxy.value)(v))(Data_Unit.unit)();
        };
    };
};
var withFinal_ = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        return function (f) {
            return function (block) {
                return Specular_FRP_Replaceable.withDynamic_(dictMonadReplace)(dictMonadFRP)(Restaumatic_Form_Final.unFinal(f))(Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableMaybe)(block));
            };
        };
    };
};
var validateJust = function (validation) {
    return function (value) {
        return Restaumatic_Form_Final.bindFinal(value)(function (v) {
            if (v instanceof Data_Maybe.Just) {
                return validation(Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(v.value0));
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)([  ]);
            };
            throw new Error("Failed pattern match at Restaumatic.Form (line 617, column 51 - line 619, column 21): " + [ v.constructor.name ]);
        });
    };
};
var userEdit = function (v) {
    return Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "event";
        }
    })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "userEdit";
        }
    })())(Data_Symbol.SProxy.value)(v));
};
var uniqFinal = function (dictMonadFRP) {
    return function (dictEq) {
        var $335 = Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(Restaumatic_Form_Final.makeFinalV);
        var $336 = Specular_FRP_Base.uniqDynBy(dictMonadFRP)(Data_Eq.eq(Data_Validation_Semigroup.eqV(Data_Map_Internal.eqMap(Data_Maybe.eqMaybe(Data_Eq.eqArray(Data_Eq.eqString)))(Data_Eq.eqArray(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
            reflectSymbol: function () {
                return "message";
            }
        })(Data_Eq.eqString))()({
            reflectSymbol: function () {
                return "internal";
            }
        })(Data_Eq.eqBoolean))()({
            reflectSymbol: function () {
                return "fieldName";
            }
        })(Data_Maybe.eqMaybe(Data_Eq.eqArray(Data_Eq.eqString))))()({
            reflectSymbol: function () {
                return "fieldLabel";
            }
        })(Data_Maybe.eqMaybe(Data_Eq.eqString))))))(dictEq)));
        return function ($337) {
            return $335($336(Restaumatic_Form_Final.unFinalV($337)));
        };
    };
};
var unFinalWithDefault = function (def) {
    var $338 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.fromMaybe(def));
    return function ($339) {
        return $338(Restaumatic_Form_Final.unFinal($339));
    };
};
var unFinalFromContextDef = function (d) {
    return function (key) {
        return function (ctxRef) {
            return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(ctxRef))(function (context1) {
                return Data_Maybe.maybe(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(d))(unFinalWithDefault(d))(Data_Vault.lookup(key)(context1));
            });
        };
    };
};
var unFinalFromContext = function (key) {
    return function (ctxRef) {
        return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(ctxRef))(function (context1) {
            return Data_Maybe.maybe(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Maybe.Nothing.value))(Restaumatic_Form_Final.unFinal)(Data_Vault.lookup(key)(context1));
        });
    };
};
var touch = function (v) {
    return writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "touched";
        }
    })())(Data_Symbol.SProxy.value)(v))(true);
};
var toRecord = function (dict) {
    return dict.toRecord;
};
var textInput = function (dict) {
    return dict.textInput;
};
var tagErrors = function (fieldName) {
    return function (errors) {
        return Data_Map_Internal.insertWith(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(Data_Semigroup.append(Data_Semigroup.semigroupArray))(new Data_Maybe.Just(fieldName))(Data_Functor.mapFlipped(Data_Functor.functorArray)(Data_Maybe.fromMaybe([  ])(Data_Map_Internal.lookup(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(Data_Maybe.Nothing.value)(errors)))(function (error) {
            return {
                fieldName: new Data_Maybe.Just(fieldName),
                fieldLabel: error.fieldLabel,
                internal: error.internal,
                message: error.message
            };
        }))(Data_Map_Internal["delete"](Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(Data_Maybe.Nothing.value)(errors));
    };
};
var singleOption = function (label) {
    return function (key) {
        return new Specular_Select.SingleOption({
            label: label,
            key: key,
            disabled: false
        });
    };
};
var withOptions = function (field) {
    return function (label) {
        return {
            field: field,
            toOption: function (a) {
                return singleOption(label(a))(a);
            }
        };
    };
};
var selectWriteValue = function (dict) {
    return dict.selectWriteValue;
};
var selectTouch = function (dict) {
    return dict.selectTouch;
};
var selectReadValue = function (dict) {
    return dict.selectReadValue;
};
var selectGetOptions = function (dict) {
    return dict.selectGetOptions;
};
var selectInput = function (dictShow) {
    return function (dictEq) {
        return function (dictIsSelectField) {
            return function (ff) {
                var contains = function (v) {
                    return function (v1) {
                        if (v1 instanceof Specular_Select.SingleOption) {
                            return Data_Eq.eq(dictEq)(v1.value0.key)(v);
                        };
                        if (v1 instanceof Specular_Select.OptGroup) {
                            return Data_Array.any(function (o) {
                                return Data_Eq.eq(dictEq)(Data_Record.getField(Data_Record.hasFieldRecord({
                                    reflectSymbol: function () {
                                        return "key";
                                    }
                                })())(Data_Symbol.SProxy.value)(o))(v);
                            })(v1.value0.options);
                        };
                        throw new Error("Failed pattern match at Restaumatic.Form (line 837, column 3 - line 837, column 47): " + [ v.constructor.name, v1.constructor.name ]);
                    };
                };
                var extraOption = function (stdOptions) {
                    return function (value) {
                        if (value instanceof Data_Maybe.Just && Data_Array.any(contains(value.value0))(stdOptions)) {
                            return [  ];
                        };
                        if (value instanceof Data_Maybe.Just) {
                            return [ new Specular_Select.SingleOption({
                                key: new Data_Maybe.Just(value.value0),
                                label: Data_Show.show(dictShow)(value.value0),
                                disabled: false
                            }) ];
                        };
                        if (value instanceof Data_Maybe.Nothing) {
                            return [ new Specular_Select.SingleOption({
                                key: Data_Maybe.Nothing.value,
                                label: "",
                                disabled: false
                            }) ];
                        };
                        throw new Error("Failed pattern match at Restaumatic.Form (line 829, column 5 - line 835, column 70): " + [ value.constructor.name ]);
                    };
                };
                return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)({
                    onChange: function (v) {
                        if (v instanceof Data_Maybe.Just) {
                            return selectWriteValue(dictIsSelectField)(ff)(v.value0);
                        };
                        if (v instanceof Data_Maybe.Nothing) {
                            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
                        };
                        throw new Error("Failed pattern match at Restaumatic.Form (line 814, column 9 - line 819, column 22): " + [ v.constructor.name ]);
                    },
                    displayedValue: Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create)(selectReadValue(dictIsSelectField)(ff)),
                    displayedOptions: Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
                        return function (v1) {
                            return Data_Semigroup.append(Data_Semigroup.semigroupArray)(extraOption(v)(v1))(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(Specular_Select.functorOption)(Data_Maybe.Just.create))(v));
                        };
                    })(selectGetOptions(dictIsSelectField)(ff)))(selectReadValue(dictIsSelectField)(ff)),
                    onTouch: selectTouch(dictIsSelectField)(ff)
                });
            };
        };
    };
};
var requiredError = function (v) {
    return Restaumatic_Form_Final.userVisibleError(Restaumatic_I18n.translate_(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "required";
        }
    })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "errors";
        }
    })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "form";
        }
    })())(Data_Symbol.SProxy.value)(Restaumatic_Common_Translations_Keys.t)))));
};
var readValue = function (v) {
    return Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "readValue";
        }
    })())(Data_Symbol.SProxy.value)(v);
};
var queryWith = function (dict) {
    return dict.queryWith;
};
var queryUnit = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            return function (v1) {
                return Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(Data_Unit.unit);
            };
        }
    };
};
var queryRef = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            var $340 = Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Type_Equality.from(dictTypeEquals));
            return function ($341) {
                return $340(Restaumatic_Form_Final.liftDynamic(Specular_Ref.value($341)));
            };
        }
    };
};
var queryRecordNil = {
    queryRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(Control_Category.identity(Record_Builder.categoryBuilder));
            };
        };
    }
};
var queryRecord = function (dict) {
    return dict.queryRecord;
};
var queryRecordCons = function (dictIsSymbol) {
    return function (dictQueryRecord) {
        return function (dictQuery) {
            return function (dictCons) {
                return function (dictLacks) {
                    return function (dictCons1) {
                        return function (dictLacks1) {
                            return {
                                queryRecord: function (strictness) {
                                    return function (v) {
                                        return function (f) {
                                            return Control_Apply.apply(Restaumatic_Form_Final.applyFinal)(Data_Functor.map(Restaumatic_Form_Final.functorFinal)(function (v1) {
                                                return function (v2) {
                                                    return Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder)(v2)(Record_Builder.insert()()(dictIsSymbol)(Data_Symbol.SProxy.value)(v1));
                                                };
                                            })(queryWith(dictQuery)(strictness)(Record.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(f))))(queryRecord(dictQueryRecord)(strictness)(Type_Data_RowList.RLProxy.value)(f));
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var queryLaxWithDefault = function (dictQuery) {
    return function (def) {
        var $342 = unFinalWithDefault(def);
        var $343 = queryWith(dictQuery)(Lax.value);
        return function ($344) {
            return $342($343($344));
        };
    };
};
var queryLax = function (dictQuery) {
    return queryWith(dictQuery)(Lax.value);
};
var queryFormFieldI = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            return function (v1) {
                if (v instanceof Lax) {
                    return Restaumatic_Form_Final.makeFinalV(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Bifunctor.bimap(Data_Validation_Semigroup.bifunctorV)(tagErrors(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "name";
                        }
                    })())(Data_Symbol.SProxy.value)(v1)))(Type_Equality.from(dictTypeEquals)))(Restaumatic_Form_Final.unFinalV(readValue(v1))));
                };
                if (v instanceof Strict) {
                    return Restaumatic_Form_Final.makeFinalV(Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v2) {
                        return function (v3) {
                            return Data_Bifunctor.lmap(Data_Validation_Semigroup.bifunctorV)(tagErrors(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "name";
                                }
                            })())(Data_Symbol.SProxy.value)(v1)))(Data_Validation_Semigroup.andThen(v3)(function (value$prime) {
                                return Data_Validation_Semigroup.andThen(v2)(function (errors$prime) {
                                    var $220 = Data_Array["null"](errors$prime);
                                    if ($220) {
                                        return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))))(Type_Equality.from(dictTypeEquals)(value$prime));
                                    };
                                    return Data_Validation_Semigroup.invalid(Data_Map_Internal.singleton(new Data_Maybe.Just(Data_Record.getField(Data_Record.hasFieldRecord({
                                        reflectSymbol: function () {
                                            return "name";
                                        }
                                    })())(Data_Symbol.SProxy.value)(v1)))(Data_Functor.mapFlipped(Data_Functor.functorArray)(errors$prime)(function (message) {
                                        return {
                                            fieldName: new Data_Maybe.Just(Data_Record.getField(Data_Record.hasFieldRecord({
                                                reflectSymbol: function () {
                                                    return "name";
                                                }
                                            })())(Data_Symbol.SProxy.value)(v1)),
                                            fieldLabel: Data_Maybe.Nothing.value,
                                            message: message,
                                            internal: false
                                        };
                                    })));
                                });
                            }));
                        };
                    })(Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "validations";
                        }
                    })())(Data_Symbol.SProxy.value)(v1)))(function (validations$prime) {
                        return Restaumatic_Form_Final.unFinalV(Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Data_Array.concat)(Data_Traversable.sequence(Data_Traversable.traversableArray)(Restaumatic_Form_Final.applicativeFinal)(validations$prime)));
                    })))(Restaumatic_Form_Final.unFinalV(readValue(v1))));
                };
                throw new Error("Failed pattern match at Restaumatic.Form (line 438, column 1 - line 457, column 14): " + [ v.constructor.name, v1.constructor.name ]);
            };
        }
    };
};
var readValidationErrors = function (v) {
    var getErrors = (function () {
        var $345 = Data_Functor.map(Data_Functor.functorArray)(function (v1) {
            return Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "message";
                }
            })())(Data_Symbol.SProxy.value)(v1);
        });
        var $346 = Data_Maybe.fromMaybe([  ]);
        var $347 = Data_Map_Internal.lookup(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))(new Data_Maybe.Just(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "name";
            }
        })())(Data_Symbol.SProxy.value)(v)));
        return function ($348) {
            return $345($346($347($348)));
        };
    })();
    return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation(getErrors)(function (v1) {
        return [  ];
    }))(Restaumatic_Form_Final.unFinalV(queryWith(queryFormFieldI(Type_Equality.refl))(Strict.value)(v)));
};
var queryFinal = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            return Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Type_Equality.from(dictTypeEquals));
        }
    };
};
var queryDynamic = function (dictTypeEquals) {
    return {
        queryWith: function (v) {
            var $349 = Data_Functor.map(Restaumatic_Form_Final.functorFinal)(Type_Equality.from(dictTypeEquals));
            return function ($350) {
                return $349(Restaumatic_Form_Final.liftDynamic($350));
            };
        }
    };
};
var query = function (dictQuery) {
    return queryWith(dictQuery)(Strict.value);
};
var optionForEq = function (dictHasOptions) {
    return Unsafe_Coerce.unsafeCoerce;
};
var readOptions = function (dictHasOptions) {
    return function (v) {
        return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "options";
            }
        })())(Data_Symbol.SProxy.value)(v)))(function (optionsDef) {
            return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.maybe([  ])(Data_Leibniz.runLeibniz(optionForEq())))(Restaumatic_Form_Final.unFinal(optionsDef));
        });
    };
};
var nonEmpty = Data_Functor.map(Restaumatic_Form_Final.functorFinal)(function (s) {
    return Data_Monoid_Extra.mwhen(Data_Monoid.monoidArray)(s === "")([ Restaumatic_I18n.translate_(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "required";
        }
    })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "errors";
        }
    })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "form";
        }
    })())(Data_Symbol.SProxy.value)(Restaumatic_Common_Translations_Keys.t)))) ]);
});
var monadFormDefM = Specular_FRP_Host.monadHost;
var monadEffectFormDefM = Specular_FRP_Host.monadEffectHost;
var normalize = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(monadEffectFormDefM)(writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "normalize";
            }
        })())(Data_Symbol.SProxy.value)(v1))(v));
    };
};
var onWriteValue = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(monadEffectFormDefM)(Effect_Ref.write(v)(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "onWriteValue";
            }
        })())(Data_Symbol.SProxy.value)(v1)));
    };
};
var options = function (dictHasOptions) {
    return function (v) {
        return function (v1) {
            return Effect_Class.liftEffect(monadEffectFormDefM)(writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "options";
                }
            })())(Data_Symbol.SProxy.value)(v1))(Data_Leibniz.runLeibniz(Data_Leibniz.liftLeibniz(Data_Leibniz.symm(optionForEq())))(v)));
        };
    };
};
var validations = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(monadEffectFormDefM)(writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "validations";
            }
        })())(Data_Symbol.SProxy.value)(v1))(Data_Functor.map(Data_Functor.functorArray)(function (v2) {
            return v2(readValue(v1));
        })(v)));
    };
};
var monadCleanupFormDefM = Specular_FRP_Host.monadCleanupHost;
var modifyValidValue = function (v) {
    return function (update) {
        return function __do() {
            var old = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(Restaumatic_Form_Final.unFinal(readValue(v)))();
            writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "value";
                }
            })())(Data_Symbol.SProxy.value)(v))(Valid.create(update(old)))();
            touch(v)();
            return Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "fire";
                }
            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "userEdit";
                }
            })())(Data_Symbol.SProxy.value)(v))(Data_Unit.unit)();
        };
    };
};
var mergeUnit = function (dictTypeEquals) {
    return {
        merge: function (v) {
            return function (v1) {
                return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
            };
        }
    };
};
var mergeRecordNil = {
    mergeRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
            };
        };
    }
};
var mergeRecord = function (dict) {
    return dict.mergeRecord;
};
var merge_Record = function (dictAsRecord) {
    return function (dictRowToList) {
        return function (dictMergeRecord) {
            return {
                merge: function (d) {
                    return function (f) {
                        return mergeRecord(dictMergeRecord)(Type_Data_RowList.RLProxy.value)(toRecord(dictAsRecord)(d))(f);
                    };
                }
            };
        };
    };
};
var mergeInputRequiredFormField = {
    mergeInputRequired: function (v) {
        return Specular_Callback.triggerCallback(Specular_Ref.set(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "value";
            }
        })())(Data_Symbol.SProxy.value)(v)))(InputRequired.value);
    }
};
var mergeInputRequired = function (dict) {
    return dict.mergeInputRequired;
};
var mergeFormField = function (dictTypeEquals) {
    return {
        merge: function (x) {
            return function (v) {
                return Specular_Callback.triggerCallback(Specular_Ref.set(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "value";
                    }
                })())(Data_Symbol.SProxy.value)(v)))(new Valid(Type_Equality.to(dictTypeEquals)(x)));
            };
        }
    };
};
var merge = function (dict) {
    return dict.merge;
};
var mergeRecordCons = function (dictIsSymbol) {
    return function (dictMergeRecord) {
        return function (dictMerge) {
            return function (dictCons) {
                return function (dictLacks) {
                    return function (dictCons1) {
                        return function (dictLacks1) {
                            return {
                                mergeRecord: function (v) {
                                    return function (r) {
                                        return function (f) {
                                            return function __do() {
                                                Specular_Profiling.measure(Effect_Class.monadEffectEffect)("merge " + Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value))(merge(dictMerge)(Record.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(r))(Record.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(f)))();
                                                return mergeRecord(dictMergeRecord)(Type_Data_RowList.RLProxy.value)(r)(f)();
                                            };
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var mapVFinal = function (f) {
    var $351 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f));
    return function ($352) {
        return Restaumatic_Form_Final.makeFinalV($351(Restaumatic_Form_Final.unFinalV($352)));
    };
};
var mapMaybeFinalUserVisible = function (errorMessage) {
    return function (f) {
        var f$prime = function (x) {
            var v = f(x);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid(Restaumatic_Form_Final.userVisibleError(errorMessage));
            };
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))))(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Form (line 393, column 5 - line 395, column 23): " + [ v.constructor.name ]);
        };
        var $353 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f$prime));
        return function ($354) {
            return Restaumatic_Form_Final.makeFinalV($353(Restaumatic_Form_Final.unFinalV($354)));
        };
    };
};
var mapMaybeFinalInternal = function (errorMessage) {
    return function (f) {
        var f$prime = function (x) {
            var v = f(x);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid(Restaumatic_Form_Final.internalError(errorMessage));
            };
            if (v instanceof Data_Maybe.Just) {
                return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))))(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Form (line 403, column 5 - line 405, column 23): " + [ v.constructor.name ]);
        };
        var $355 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f$prime));
        return function ($356) {
            return Restaumatic_Form_Final.makeFinalV($355(Restaumatic_Form_Final.unFinalV($356)));
        };
    };
};
var mapMaybeFinal = mapMaybeFinalInternal("Unknown error (mapMaybeFinal)");
var mapDynamicFinal = function (f) {
    return function ($357) {
        return Restaumatic_Form_Final.makeFinalV((function (v) {
            return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(v)(Data_Traversable.traverse(Data_Validation_Semigroup.traversableV)(Specular_FRP_Base.applicativeDynamic)(f));
        })(Restaumatic_Form_Final.unFinalV($357)));
    };
};
var makeEmptyRecordNil = {
    makeEmptyRecord: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Effect.applicativeEffect)(Control_Category.identity(Record_Builder.categoryBuilder));
        };
    }
};
var makeEmptyRecord = function (dict) {
    return dict.makeEmptyRecord;
};
var makeEmpty_Record = function (dictRowToList) {
    return function (dictMakeEmptyRecord) {
        return {
            makeEmptyImpl: function (opts) {
                return function __do() {
                    var b = makeEmptyRecord(dictMakeEmptyRecord)(Type_Data_RowList.RLProxy.value)(opts)();
                    return Record_Builder.build(b)({});
                };
            }
        };
    };
};
var makeEmptyImpl = function (dict) {
    return dict.makeEmptyImpl;
};
var makeEmptyRecordCons = function (dictIsSymbol) {
    return function (dictMakeEmptyRecord) {
        return function (dictMakeEmpty) {
            return function (dictCons) {
                return function (dictLacks) {
                    return {
                        makeEmptyRecord: function (v) {
                            return function (opts) {
                                return function __do() {
                                    var x = makeEmptyImpl(dictMakeEmpty)({
                                        name: Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Record.getField(Data_Record.hasFieldRecord({
                                            reflectSymbol: function () {
                                                return "name";
                                            }
                                        })())(Data_Symbol.SProxy.value)(opts))([ Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value) ])
                                    })();
                                    var xs = makeEmptyRecord(dictMakeEmptyRecord)(Type_Data_RowList.RLProxy.value)(opts)();
                                    return Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder)(xs)(Record_Builder.insert()()(dictIsSymbol)(Data_Symbol.SProxy.value)(x));
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var makeEmpty = function (dictMonadEffect) {
    return function (dictMakeEmpty) {
        return Effect_Class.liftEffect(dictMonadEffect)(makeEmptyImpl(dictMakeEmpty)({
            name: [  ]
        }));
    };
};
var mSelectWriteValue = function (dict) {
    return dict.mSelectWriteValue;
};
var mSelectTouch = function (dict) {
    return dict.mSelectTouch;
};
var mSelectReadValue = function (dict) {
    return dict.mSelectReadValue;
};
var mSelectGetOptions = function (dict) {
    return dict.mSelectGetOptions;
};
var liftMaybe = (function () {
    var $358 = Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
    return function ($359) {
        return Restaumatic_Form_Final.makeFinal($358($359));
    };
})();
var liftHost = function (dictMonadFRP) {
    return function (h) {
        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(Specular_FRP_Host.runHost(h)))(function (v) {
            return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Cleanup.onCleanup(dictMonadFRP.MonadCleanup1())(v.value1))(function () {
                return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(v.value0);
            });
        });
    };
};
var lessThanOrEqual = function (dictOrd) {
    return function (dictShow) {
        return Control_Apply.lift2(Restaumatic_Form_Final.applyFinal)(function (threshold) {
            return function (value) {
                return Data_Monoid_Extra.munless(Data_Monoid.monoidArray)(Data_Ord.lessThanOrEq(dictOrd)(value)(threshold))([ Restaumatic_I18n.translate(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "lessThanOrEqual";
                    }
                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "errors";
                    }
                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "form";
                    }
                })())(Data_Symbol.SProxy.value)(Restaumatic_Common_Translations_Keys.t))))({
                    threshold: Data_Show.show(dictShow)(threshold)
                }) ]);
            };
        });
    };
};
var lessThan = function (dictOrd) {
    return function (dictShow) {
        return Control_Apply.lift2(Restaumatic_Form_Final.applyFinal)(function (threshold) {
            return function (value) {
                return Data_Monoid_Extra.munless(Data_Monoid.monoidArray)(Data_Ord.lessThan(dictOrd)(value)(threshold))([ Restaumatic_I18n.translate(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "lessThan";
                    }
                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "errors";
                    }
                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "form";
                    }
                })())(Data_Symbol.SProxy.value)(Restaumatic_Common_Translations_Keys.t))))({
                    threshold: Data_Show.show(dictShow)(threshold)
                }) ]);
            };
        });
    };
};
var isTextFieldRef = {
    textInput: function (f) {
        return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)({
            onChange: function (value) {
                return writeRef(f)(value);
            },
            onTouch: Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit),
            displayedValue: Specular_Ref.value(f),
            placeholder: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)("")
        });
    }
};
var isTextFieldOldFormField = {
    textInput: function (f) {
        return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)({
            onChange: function (value) {
                return writeRef(Specular_FormField.editRef(f))(value);
            },
            onTouch: Specular_Callback.triggerCallback(Specular_FormField.focusOutCallback(f))(Data_Unit.unit),
            displayedValue: Specular_Ref.value(Specular_FormField.editRef(f)),
            placeholder: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)("")
        });
    }
};
var isTextFieldNewFormField = function (dictEditAsString) {
    return {
        textInput: function (v) {
            var parse$prime = (function () {
                var $360 = Data_Maybe.maybe(new Invalid(Restaumatic_I18n.translate_(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "invalid";
                    }
                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "errors";
                    }
                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "form";
                    }
                })())(Data_Symbol.SProxy.value)(Restaumatic_Common_Translations_Keys.t))))))(Valid.create);
                var $361 = Restaumatic_Form_EditAsString.parse(dictEditAsString);
                return function ($362) {
                    return $360($361($362));
                };
            })();
            var onChange = function (str) {
                return function __do() {
                    Specular_Ref.write(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "editValue";
                        }
                    })())(Data_Symbol.SProxy.value)(v))(new Data_Maybe.Just(str))();
                    Specular_Ref.write(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "value";
                        }
                    })())(Data_Symbol.SProxy.value)(v))(parse$prime(str))();
                    return Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "fire";
                        }
                    })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "userEdit";
                        }
                    })())(Data_Symbol.SProxy.value)(v))(Data_Unit.unit)();
                };
            };
            return Control_Bind.bind(Specular_FRP_Host.bindHost)(Specular_FRP_Base.uniqDynBy(Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost))(Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqString)))(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Functor.map(Data_Maybe.functorMaybe)(Restaumatic_Form_EditAsString.toString(dictEditAsString)))(Restaumatic_Form_Final.unFinal(readValue(v)))))(function (editValueFromTyped) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Specular_FRP_Host.bindHost)(Data_Function.flip(Specular_FRP_Base.subscribeDyn_(Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost)))(editValueFromTyped)(function (m_str) {
                    return Specular_Extra_Async.nextMicrotask((function () {
                        if (m_str instanceof Data_Maybe.Just) {
                            return writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                                reflectSymbol: function () {
                                    return "editValue";
                                }
                            })())(Data_Symbol.SProxy.value)(v))(new Data_Maybe.Just(m_str.value0));
                        };
                        if (m_str instanceof Data_Maybe.Nothing) {
                            return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
                        };
                        throw new Error("Failed pattern match at Restaumatic.Form (line 706, column 7 - line 710, column 20): " + [ m_str.constructor.name ]);
                    })());
                }))(function () {
                    return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)({
                        displayedValue: Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.fromMaybe(""))(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "editValue";
                            }
                        })())(Data_Symbol.SProxy.value)(v))),
                        onChange: onChange,
                        onTouch: writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                            reflectSymbol: function () {
                                return "touched";
                            }
                        })())(Data_Symbol.SProxy.value)(v))(true),
                        placeholder: Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)("")
                    });
                });
            });
        }
    };
};
var isSelectFieldRefWithOptions = {
    selectWriteValue: function (v) {
        return function (a) {
            return Specular_Ref.updateRef(Effect_Class.monadEffectEffect)(v.field)(a);
        };
    },
    selectReadValue: function (v) {
        return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create)(Specular_Ref.value(v.field));
    },
    selectGetOptions: function (v) {
        return v.choices;
    },
    selectTouch: function (f) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    }
};
var isSelectFieldFormField = function (dictHasOptions) {
    return {
        selectWriteValue: function (f) {
            return function (a) {
                return writeValue(f)(new Valid(a));
            };
        },
        selectReadValue: function (f) {
            return Restaumatic_Form_Final.unFinal(readValue(f));
        },
        selectGetOptions: readOptions(),
        selectTouch: function (v) {
            return writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "touched";
                }
            })())(Data_Symbol.SProxy.value)(v))(true);
        }
    };
};
var isSelectFieldChoiceRef = {
    selectWriteValue: function (v) {
        return function (a) {
            return Specular_Ref.updateRef(Effect_Class.monadEffectEffect)(v.field.currentChoice)(a);
        };
    },
    selectReadValue: function (v) {
        return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create)(Specular_Ref.value(Specular_ChoiceRef.currentChoice(v.field)));
    },
    selectGetOptions: function (v) {
        return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Functor.map(Data_Functor.functorArray)(v.toOption))(Specular_ChoiceRef.choices(v.field));
    },
    selectTouch: function (f) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    }
};
var isMultiSelectFieldMultiChoiceRef = {
    mSelectWriteValue: function (v) {
        return function (a) {
            return Specular_Ref.updateRef(Effect_Class.monadEffectEffect)(v.field.currentChoices)(a);
        };
    },
    mSelectReadValue: function (v) {
        return Specular_Ref.value(Specular_MultiChoiceRef.currentChoices(v.field));
    },
    mSelectGetOptions: function (v) {
        return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Functor.map(Data_Functor.functorArray)(v.toOption))(Specular_MultiChoiceRef.choices(v.field));
    },
    mSelectTouch: function (f) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    }
};
var isCheckboxFieldInputRef = {
    checkboxInput: function (f) {
        return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)({
            onChange: function (value) {
                return Specular_Ref.updateRef(Effect_Class.monadEffectEffect)(f)(value);
            },
            displayedValue: Specular_Ref.value(f)
        });
    }
};
var isCheckboxFieldFormField = {
    checkboxInput: function (v) {
        return Effect_Class.liftEffect(Specular_FRP_Host.monadEffectHost)(function __do() {
            var initial = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(Restaumatic_Form_Final.unFinal(readValue(v)))();
            Control_Applicative.when(Effect.applicativeEffect)(Data_Maybe.isNothing(initial))(writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "value";
                }
            })())(Data_Symbol.SProxy.value)(v))(new Valid(false)))();
            return {
                displayedValue: Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.fromMaybe(false))(Restaumatic_Form_Final.unFinal(readValue(v))),
                onChange: (function () {
                    var $363 = writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "value";
                        }
                    })())(Data_Symbol.SProxy.value)(v));
                    return function ($364) {
                        return $363(Valid.create($364));
                    };
                })()
            };
        });
    }
};
var hasOptionsSingle = {};
var hasOptionsSet = {};
var hasOptionsSMultiSet = {};
var hasOptionsArray = {};
var hasErrorsOldFormField = {
    displayedErrors: Specular_FormField.displayedErrors
};
var hasErrorsErrorArray = {
    displayedErrors: unFinalWithDefault(Data_Monoid.mempty(Data_Monoid.monoidArray))
};
var greaterThanOrEqual = function (dictOrd) {
    return function (dictShow) {
        return Control_Apply.lift2(Restaumatic_Form_Final.applyFinal)(function (threshold) {
            return function (value) {
                return Data_Monoid_Extra.munless(Data_Monoid.monoidArray)(Data_Ord.greaterThanOrEq(dictOrd)(value)(threshold))([ Restaumatic_I18n.translate(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "greaterThanOrEqual";
                    }
                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "errors";
                    }
                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "form";
                    }
                })())(Data_Symbol.SProxy.value)(Restaumatic_Common_Translations_Keys.t))))({
                    threshold: Data_Show.show(dictShow)(threshold)
                }) ]);
            };
        });
    };
};
var greaterThan = function (dictOrd) {
    return function (dictShow) {
        return Control_Apply.lift2(Restaumatic_Form_Final.applyFinal)(function (threshold) {
            return function (value) {
                return Data_Monoid_Extra.munless(Data_Monoid.monoidArray)(Data_Ord.greaterThan(dictOrd)(value)(threshold))([ Restaumatic_I18n.translate(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "greaterThan";
                    }
                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "errors";
                    }
                })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "form";
                    }
                })())(Data_Symbol.SProxy.value)(Restaumatic_Common_Translations_Keys.t))))({
                    threshold: Data_Show.show(dictShow)(threshold)
                }) ]);
            };
        });
    };
};
var genericTypedValue = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Undefined.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Invalid(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new Valid(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return InputRequired.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Form (line 77, column 1 - line 77, column 62): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Undefined) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Invalid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Valid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof InputRequired) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.Form (line 77, column 1 - line 77, column 62): " + [ x.constructor.name ]);
    }
};
var showTypedValue = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericTypedValue)(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "Undefined";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
            reflectSymbol: function () {
                return "Invalid";
            }
        }))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(dictShow))({
            reflectSymbol: function () {
                return "Valid";
            }
        }))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
            reflectSymbol: function () {
                return "InputRequired";
            }
        })))))
    };
};
var functorFormDefM = Specular_FRP_Host.functorHost;
var fromValid = function (v) {
    if (v instanceof Valid) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
};
var fromRecord = function (dict) {
    return dict.fromRecord;
};
var query_Record = function (dictAsRecord) {
    return function (dictRowToList) {
        return function (dictQueryRecord) {
            return {
                queryWith: function (strictness) {
                    return function (f) {
                        return Data_Functor.map(Restaumatic_Form_Final.functorFinal)((function () {
                            var $365 = fromRecord(dictAsRecord);
                            var $366 = Data_Function.flip(Record_Builder.build)({});
                            return function ($367) {
                                return $365($366($367));
                            };
                        })())(queryRecord(dictQueryRecord)(strictness)(Type_Data_RowList.RLProxy.value)(f));
                    };
                }
            };
        };
    };
};
var fromChoices = function (dictFoldable) {
    return function (field) {
        return function (cs) {
            return {
                field: field,
                choices: Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(cs)(Data_Array.fromFoldable(dictFoldable)))(Data_Functor.map(Data_Functor.functorArray)(function (r) {
                    return singleOption(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "name";
                        }
                    })())(Data_Symbol.SProxy.value)(r))(Data_Record.getField(Data_Record.hasFieldRecord({
                        reflectSymbol: function () {
                            return "id";
                        }
                    })())(Data_Symbol.SProxy.value)(r));
                }))
            };
        };
    };
};
var forceDisplayErrorsKey = Data_Vault.unsafeNewKey(Data_Eq.eqInt);
var forceDisplayErrors = Data_Vault.singleton(forceDisplayErrorsKey);
var failFirst = function (validations_) {
    return function (value) {
        return Restaumatic_Form_Final.bindFinal(value)(function (value_) {
            var validationValuesD = Data_Functor.map(Data_Functor.functorArray)((function () {
                var $368 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.fromMaybe([  ]));
                return function ($369) {
                    return $368(Restaumatic_Form_Final.unFinal((function (v) {
                        return v(Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)(value_));
                    })($369)));
                };
            })())(validations_);
            var validationValues = Data_Traversable.sequence(Data_Traversable.traversableArray)(Specular_FRP_Base.applicativeDynamic)(validationValuesD);
            var findFirst = (function () {
                var $370 = Data_Maybe.fromMaybe([  ]);
                var $371 = Data_Foldable.find(Data_Foldable.foldableArray)(function (e) {
                    return Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt)(e) > 0;
                });
                return function ($372) {
                    return $370($371($372));
                };
            })();
            var result = Data_Functor.map(Specular_FRP_Base.functorDynamic)(function ($373) {
                return Data_Maybe.Just.create(findFirst($373));
            })(validationValues);
            return Restaumatic_Form_Final.makeFinal(result);
        });
    };
};
var eqStrictness = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Strict && y instanceof Strict) {
                return true;
            };
            if (x instanceof Lax && y instanceof Lax) {
                return true;
            };
            return false;
        };
    }
};
var encodeTypedValue = function (dictEncode) {
    return {
        encode: Foreign_Encoding.defaultEncode(genericTypedValue)(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "Undefined";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "Invalid";
            }
        })(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))(Foreign_Generic_Class.genericEncodeSum(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "Valid";
            }
        })(Foreign_Generic_Class.genericEncodeArgsArgument(Foreign_Generic_Class.encodeWithOptionsOther(dictEncode))))(Foreign_Generic_Class.genericEncodeConstructor({
            reflectSymbol: function () {
                return "InputRequired";
            }
        })(Foreign_Generic_Class.genericEncodeArgsNoArguments)))))
    };
};
var dynamicFromContextDef = function (d) {
    return function (key) {
        return function (ctxRef) {
            return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(ctxRef))(function (context1) {
                return Data_Maybe.fromMaybe(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(d))(Data_Vault.lookup(key)(context1));
            });
        };
    };
};
var dynamicFromContext = function (key) {
    return function (ctxRef) {
        return Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(ctxRef))(function (context1) {
            return Data_Traversable.sequence(Data_Traversable.traversableMaybe)(Specular_FRP_Base.applicativeDynamic)(Data_Vault.lookup(key)(context1));
        });
    };
};
var hasErrorsFormField = {
    displayedErrors: function (v) {
        return Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v1) {
            return function (v2) {
                return function (v3) {
                    var $300 = v1 || v2;
                    if ($300) {
                        return v3;
                    };
                    return [  ];
                };
            };
        })(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "touched";
            }
        })())(Data_Symbol.SProxy.value)(v))))(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.fromMaybe(false))(dynamicFromContext(forceDisplayErrorsKey)(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "context";
            }
        })())(Data_Symbol.SProxy.value)(v)))))(readValidationErrors(v));
    }
};
var dumpStateRecordNil = {
    dumpStateRecord: function (v) {
        return function (v1) {
            return Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Foreign_Object.empty);
        };
    }
};
var dumpStateRecord = function (dict) {
    return dict.dumpStateRecord;
};
var dumpState_Record = function (dictRowToList) {
    return function (dictDumpStateRecord) {
        return {
            dumpState: (function () {
                var $374 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode)));
                var $375 = dumpStateRecord(dictDumpStateRecord)(Type_Data_RowList.RLProxy.value);
                return function ($376) {
                    return $374($375($376));
                };
            })()
        };
    };
};
var dumpState = function (dict) {
    return dict.dumpState;
};
var dumpStateRecordCons = function (dictIsSymbol) {
    return function (dictDumpStateRecord) {
        return function (dictDumpState) {
            return function (dictCons) {
                return function (dictLacks) {
                    return {
                        dumpStateRecord: function (v) {
                            return function (f) {
                                return Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v1) {
                                    return function (v2) {
                                        return Foreign_Object.insert(Data_Symbol.reflectSymbol(dictIsSymbol)(Data_Symbol.SProxy.value))(v1)(v2);
                                    };
                                })(dumpState(dictDumpState)(Record.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(f))))(dumpStateRecord(dictDumpStateRecord)(Type_Data_RowList.RLProxy.value)(f));
                            };
                        }
                    };
                };
            };
        };
    };
};
var displayedErrors = function (dict) {
    return dict.displayedErrors;
};
var dumpStateFormField = function (dictEncode) {
    return {
        dumpState: function (v) {
            return Data_Functor.map(Specular_FRP_Base.functorDynamic)(Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                reflectSymbol: function () {
                    return "value";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(encodeTypedValue(dictEncode))))({
                reflectSymbol: function () {
                    return "touched";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
                reflectSymbol: function () {
                    return "readValue";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.foreignEncode)))({
                reflectSymbol: function () {
                    return "readValidationErrors";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))))({
                reflectSymbol: function () {
                    return "editValue";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode))))({
                reflectSymbol: function () {
                    return "displayedErrors";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode))))({
                reflectSymbol: function () {
                    return "defaultValue";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(dictEncode))))))(Record_Extra.sequenceRecord()(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "defaultValue";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "displayedErrors";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "editValue";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "readValidationErrors";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "readValue";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordCons({
                reflectSymbol: function () {
                    return "touched";
                }
            })()(Specular_FRP_Base.applyDynamic)(Record_Extra.sequenceRecordSingle({
                reflectSymbol: function () {
                    return "value";
                }
            })()(Specular_FRP_Base.functorDynamic)()())()())()())()())()())()())()())({
                value: Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "value";
                    }
                })())(Data_Symbol.SProxy.value)(v)),
                defaultValue: Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "defaultValue";
                    }
                })())(Data_Symbol.SProxy.value)(v)))(Restaumatic_Form_Final.unFinal),
                editValue: Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "editValue";
                    }
                })())(Data_Symbol.SProxy.value)(v)),
                touched: Specular_Ref.value(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "touched";
                    }
                })())(Data_Symbol.SProxy.value)(v)),
                readValue: Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.maybe(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("(NO READ VALUE)"))(Foreign_Generic_Class.encode(dictEncode)))(Restaumatic_Form_Final.unFinal(readValue(v))),
                readValidationErrors: readValidationErrors(v),
                displayedErrors: displayedErrors(hasErrorsFormField)(v)
            }));
        }
    };
};
var hasDisplayedErrors = function (dictHasErrors) {
    var $377 = Data_Functor.map(Specular_FRP_Base.functorDynamic)((function () {
        var $380 = Data_HeytingAlgebra.not(Data_HeytingAlgebra.heytingAlgebraBoolean);
        return function ($381) {
            return $380(Data_Array["null"]($381));
        };
    })());
    var $378 = displayedErrors(dictHasErrors);
    return function ($379) {
        return $377($378($379));
    };
};
var hasErrorsErrorMappedField = {
    displayedErrors: function (v) {
        return displayedErrors(hasErrorsFormField)(v.field);
    }
};
var displayLocaleKey = Data_Vault.unsafeNewKey(Data_Eq.eqInt);
var displayLocale = Data_Vault.singleton(displayLocaleKey);
var defineForm = function (dictMonadFRP) {
    return function (v) {
        return liftHost(dictMonadFRP)(v);
    };
};
var define1 = function (f) {
    return function (v) {
        return v(f);
    };
};
var defaultWriteValue = function (v) {
    return function (v1) {
        return function __do() {
            writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "value";
                }
            })())(Data_Symbol.SProxy.value)(v))(v1)();
            writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "touched";
                }
            })())(Data_Symbol.SProxy.value)(v))(true)();
            return Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "fire";
                }
            })())(Data_Symbol.SProxy.value)(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "userEdit";
                }
            })())(Data_Symbol.SProxy.value)(v))(Data_Unit.unit)();
        };
    };
};
var defaultValue = function (v) {
    return function (v1) {
        return Effect_Class.liftEffect(monadEffectFormDefM)(writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "defaultValue";
            }
        })())(Data_Symbol.SProxy.value)(v1))(v));
    };
};
var copyStateFormField = {
    copyState: function (v) {
        return function (v1) {
            return function __do() {
                Control_Bind.bind(Effect.bindEffect)(Specular_Ref.readRef(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "value";
                    }
                })())(Data_Symbol.SProxy.value)(v)))(writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "value";
                    }
                })())(Data_Symbol.SProxy.value)(v1)))();
                return Control_Bind.bind(Effect.bindEffect)(Specular_Ref.readRef(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "editValue";
                    }
                })())(Data_Symbol.SProxy.value)(v)))(writeRef(Data_Record.getField(Data_Record.hasFieldRecord({
                    reflectSymbol: function () {
                        return "editValue";
                    }
                })())(Data_Symbol.SProxy.value)(v1)))();
            };
        };
    }
};
var copyState = function (dict) {
    return dict.copyState;
};
var checkboxInput = function (dict) {
    return dict.checkboxInput;
};
var isCheckboxFieldMappedField = {
    checkboxInput: function (v) {
        return Control_Bind.bind(Specular_FRP_Host.bindHost)(checkboxInput(isCheckboxFieldFormField)(v.field))(function (v1) {
            return Control_Applicative.pure(Specular_FRP_Host.applicativeHost)({
                displayedValue: Data_Functor.map(Specular_FRP_Base.functorDynamic)(v.mapping)(v1.displayedValue),
                onChange: function ($382) {
                    return v1.onChange(v.mapping($382));
                }
            });
        });
    }
};
var bindFormDefM = Specular_FRP_Host.bindHost;
var asRecordRecord = {
    fromRecord: Control_Category.identity(Control_Category.categoryFn),
    toRecord: Control_Category.identity(Control_Category.categoryFn)
};
var asRecordNewtype = function (dictNewtype) {
    return {
        fromRecord: Data_Newtype.wrap(),
        toRecord: Data_Newtype.unwrap()
    };
};
var applyFormDefM = Specular_FRP_Host.applyHost;
var semigroupFormDefM = function (dictSemigroup) {
    return {
        append: Control_Apply.lift2(applyFormDefM)(Data_Semigroup.append(dictSemigroup))
    };
};
var applicativeFormDefM = Specular_FRP_Host.applicativeHost;
var define = function (f) {
    return Data_Foldable.traverse_(applicativeFormDefM)(Data_Foldable.foldableArray)(define1(f));
};
var monoidFormDefM = function (dictMonoid) {
    return {
        mempty: Control_Applicative.pure(applicativeFormDefM)(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupFormDefM(dictMonoid.Semigroup0());
        }
    };
};
var annotatedFinal = function (name) {
    var $383 = Specular_FRP_Base.annotated(name);
    return function ($384) {
        return Restaumatic_Form_Final.makeFinalV($383(Restaumatic_Form_Final.unFinalV($384)));
    };
};
var annotateFinal = function (dictMonadEffect) {
    var $385 = Specular_FRP_Base.annotate(dictMonadEffect);
    return function ($386) {
        return $385(Restaumatic_Form_Final.unFinal($386));
    };
};
var newEmptyFormField = function (opts) {
    return function __do() {
        var label_ = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Restaumatic_Form_Final.invalidFinal)();
        var value = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Undefined.value)();
        var editValue = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Data_Maybe.Nothing.value)();
        var defaultValue1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Restaumatic_Form_Final.makeFinalV(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Validation_Semigroup.invalid(requiredError(Data_Unit.unit)))))();
        var touched = Specular_Ref["new"](Effect_Class.monadEffectEffect)(false)();
        var options1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Control_Applicative.pure(Restaumatic_Form_Final.applicativeFinal)([  ]))();
        var validations1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)([  ])();
        var context1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Data_Monoid.mempty(Data_Vault.monoidVault))();
        var normalize1 = Specular_Ref["new"](Effect_Class.monadEffectEffect)(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Control_Category.identity(Control_Category.categoryFn)))();
        var userEdit1 = Specular_FRP_Base.newEvent(Effect_Class.monadEffectEffect)();
        var onWriteValue_ = Effect_Ref["new"](defaultWriteValue)();
        var readValue_ = Restaumatic_Form_Final.makeFinalV(Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Control_Apply.apply(Specular_FRP_Base.applyDynamic)(Data_Functor.map(Specular_FRP_Base.functorDynamic)(function (v) {
            return function (v1) {
                return function (v2) {
                    if (v2 instanceof Undefined) {
                        return Data_Bifunctor.lmap(Data_Validation_Semigroup.bifunctorV)(function (e) {
                            return Data_Semigroup.append(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString))))(requiredError(Data_Unit.unit))(e);
                        })(v);
                    };
                    if (v2 instanceof Invalid) {
                        return Data_Validation_Semigroup.invalid(Restaumatic_Form_Final.userVisibleError(v2.value0));
                    };
                    if (v2 instanceof Valid) {
                        return Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))))(v1(v2.value0));
                    };
                    if (v2 instanceof InputRequired) {
                        return Data_Validation_Semigroup.invalid(requiredError(Data_Unit.unit));
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form (line 118, column 12 - line 126, column 43): " + [ v2.constructor.name ]);
                };
            };
        })(Control_Bind.bind(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(defaultValue1))(Restaumatic_Form_Final.unFinalV)))(Control_Bind.join(Specular_FRP_Base.bindDynamic)(Specular_Ref.value(normalize1))))(Specular_Ref.value(value)));
        Specular_FRP_Base.annotate(Effect_Class.monadEffectEffect)(Specular_Ref.value(value))("FormField.value")();
        Specular_FRP_Base.annotate(Effect_Class.monadEffectEffect)(Specular_Ref.value(editValue))("FormField.editValue")();
        Specular_FRP_Base.annotate(Effect_Class.monadEffectEffect)(Specular_Ref.value(touched))("FormField.touched")();
        annotateFinal(Effect_Class.monadEffectEffect)(readValue_)("FormField.readValue")();
        return {
            name: Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "name";
                }
            })())(Data_Symbol.SProxy.value)(opts),
            label: label_,
            value: value,
            defaultValue: defaultValue1,
            editValue: editValue,
            touched: touched,
            options: options1,
            validations: validations1,
            context: context1,
            normalize: normalize1,
            userEdit: userEdit1,
            readValue: readValue_,
            onWriteValue: onWriteValue_
        };
    };
};
var makeEmptyFormField = {
    makeEmptyImpl: newEmptyFormField
};
var addContextRecordNil = {
    addContextRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
            };
        };
    }
};
var addContextRecord = function (dict) {
    return dict.addContextRecord;
};
var addContext_Record = function (dictRowToList) {
    return function (dictAddContextRecord) {
        return {
            addContext: addContextRecord(dictAddContextRecord)(Type_Data_RowList.RLProxy.value)
        };
    };
};
var addContextFormField = {
    addContext: function (ctx) {
        return function (v) {
            return Specular_Callback.triggerCallback(Specular_Ref.modify(Effect_Class.monadEffectEffect)(Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "context";
                }
            })())(Data_Symbol.SProxy.value)(v)))(function (v1) {
                return Data_Semigroup.append(Data_Vault.semigroupVault)(ctx)(v1);
            });
        };
    }
};
var addContext = function (dict) {
    return dict.addContext;
};
var addContextRecordCons = function (dictIsSymbol) {
    return function (dictAddContextRecord) {
        return function (dictAddContext) {
            return function (dictCons) {
                return function (dictLacks) {
                    return {
                        addContextRecord: function (v) {
                            return function (ctx) {
                                return function (f) {
                                    return function __do() {
                                        addContext(dictAddContext)(ctx)(Record.get(dictIsSymbol)()(Data_Symbol.SProxy.value)(f))();
                                        return addContextRecord(dictAddContextRecord)(Type_Data_RowList.RLProxy.value)(ctx)(f)();
                                    };
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var context = function (dictAddContext) {
    return function (ctx) {
        return function (f) {
            return Effect_Class.liftEffect(monadEffectFormDefM)(addContext(dictAddContext)(ctx)(f));
        };
    };
};
export {
    Attribute,
    FormDefM,
    FormField,
    MappedField,
    RefWithOptions,
    Strict,
    Lax,
    Undefined,
    Invalid,
    Valid,
    InputRequired,
    WithOptions,
    addContext,
    addContextRecord,
    annotateFinal,
    annotatedFinal,
    checkboxInput,
    context,
    copyState,
    defaultValue,
    defaultWriteValue,
    define,
    define1,
    defineForm,
    displayLocale,
    displayLocaleKey,
    displayedErrors,
    dumpState,
    dumpStateRecord,
    dynamicFromContext,
    dynamicFromContextDef,
    failFirst,
    forceDisplayErrors,
    forceDisplayErrorsKey,
    fromChoices,
    fromRecord,
    fromValid,
    greaterThan,
    greaterThanOrEqual,
    hasDisplayedErrors,
    lessThan,
    lessThanOrEqual,
    liftHost,
    liftMaybe,
    mSelectGetOptions,
    mSelectReadValue,
    mSelectTouch,
    mSelectWriteValue,
    makeEmpty,
    makeEmptyImpl,
    makeEmptyRecord,
    mapDynamicFinal,
    mapMaybeFinal,
    mapMaybeFinalInternal,
    mapMaybeFinalUserVisible,
    mapVFinal,
    merge,
    mergeInputRequired,
    mergeRecord,
    modifyValidValue,
    newEmptyFormField,
    nonEmpty,
    normalize,
    onWriteValue,
    optionForEq,
    options,
    query,
    queryLax,
    queryLaxWithDefault,
    queryRecord,
    queryWith,
    readOptions,
    readValidationErrors,
    readValue,
    requiredError,
    selectGetOptions,
    selectInput,
    selectReadValue,
    selectTouch,
    selectWriteValue,
    singleOption,
    tagErrors,
    textInput,
    toRecord,
    touch,
    unFinalFromContext,
    unFinalFromContextDef,
    unFinalWithDefault,
    uniqFinal,
    userEdit,
    validateJust,
    validations,
    withFinal_,
    withOptions,
    writeRef,
    writeValue,
    writeValueNoTouch,
    genericTypedValue,
    showTypedValue,
    encodeTypedValue,
    hasErrorsFormField,
    hasErrorsOldFormField,
    hasErrorsErrorArray,
    hasErrorsErrorMappedField,
    dumpStateFormField,
    dumpState_Record,
    dumpStateRecordNil,
    dumpStateRecordCons,
    makeEmptyFormField,
    makeEmpty_Record,
    makeEmptyRecordNil,
    makeEmptyRecordCons,
    asRecordRecord,
    asRecordNewtype,
    mergeFormField,
    mergeUnit,
    merge_Record,
    mergeInputRequiredFormField,
    mergeRecordNil,
    mergeRecordCons,
    eqStrictness,
    queryDynamic,
    queryFinal,
    queryRef,
    queryFormFieldI,
    queryUnit,
    query_Record,
    queryRecordNil,
    queryRecordCons,
    addContextFormField,
    addContext_Record,
    addContextRecordNil,
    addContextRecordCons,
    functorFormDefM,
    applyFormDefM,
    applicativeFormDefM,
    bindFormDefM,
    monadFormDefM,
    monadEffectFormDefM,
    monadCleanupFormDefM,
    semigroupFormDefM,
    monoidFormDefM,
    isTextFieldRef,
    isTextFieldOldFormField,
    isTextFieldNewFormField,
    hasOptionsArray,
    hasOptionsSet,
    hasOptionsSMultiSet,
    hasOptionsSingle,
    isSelectFieldFormField,
    isSelectFieldRefWithOptions,
    isSelectFieldChoiceRef,
    isMultiSelectFieldMultiChoiceRef,
    isCheckboxFieldFormField,
    isCheckboxFieldInputRef,
    isCheckboxFieldMappedField,
    copyStateFormField
};
export {
    parse,
    toString
} from "../Restaumatic.Form.EditAsString/index.js";
export {
    bindFinal,
    getErrors,
    internalError,
    liftDynamic,
    makeFinal,
    makeFinalV,
    unFinal,
    unFinalV,
    userVisibleError
} from "../Restaumatic.Form.Final/index.js";
export {
    newIdGenerator
} from "../Restaumatic.Form.GenerateId/index.js";
export {
    OptGroup,
    SingleOption
} from "../Specular.Select/index.js";
//# sourceMappingURL=index.js.map
